import React from "react";
import { Skeleton, Box, useTheme } from "@mui/material";
import {
  NotificationContainer,
  IconContainer,
  ContentContainer,
  StatusContainer
} from "./NotificationItem.styles";

const NotificationItemSkeleton = () => {
  const theme = useTheme();

  return (
    <NotificationContainer status={{ borderColor: theme.palette.grey[200] }}>
      <IconContainer>
        <Skeleton variant="rounded" width={28} height={28} />
      </IconContainer>
      <ContentContainer>
        <Box>
          <Skeleton variant="text" width={120} height={24} />
          <Skeleton variant="text" width={180} height={34} />
        </Box>
        <StatusContainer sx={{ mt: 1 }}>
          <Skeleton variant="text" width={60} height={16} />
          <Skeleton variant="text" width={40} height={14} />
        </StatusContainer>
      </ContentContainer>
    </NotificationContainer>
  );
};

export default NotificationItemSkeleton;
